import { format } from 'date-fns'

export const formatDateForFilter = (date: Date | string) => format(date, 'yyyy-MM-dd')
